define(
    'providers/dataprovider.accesscontrol.listvalue',[
        "services/config"        
    ],
    function (config) {

        function getAccessControl(listvalueId) {
            var data = { listvalueId: listvalueId };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "get-accesscontrol-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function addPersonAccessInListValue(rec) {
            var data = {
                listvalueId: rec.listvalueId,
                accessControlTeams: rec.teams,
                accessControlPersons: rec.persons
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accesscontrol-listvalue-person-access-in-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function addTeamAccessInListValue(rec) {
            var data = {
                listvalueId: rec.listvalueId,
                accessControlTeams: rec.teams,
                accessControlPersons: rec.persons
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accesscontrol-listvalue-team-access-in-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function updateAccessControl(rec) {
            var data = {
                listvalueId: rec.listvalueId,
                accessControlTeams: rec.teams,
                accessControlPersons: rec.persons
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accesscontrol-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function updatePersonRoleInListValue(rec) {
            var data = {                
                listvalueId: rec.listvalueId,
                personId: rec.personId,
                roleId: rec.roleId
            };
            
            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accesscontrol-listvalue-person-role-in-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function updateTeamRoleInListValue(rec) {
            var data = {
                listvalueId: rec.listvalueId,
                teamId: rec.teamId,
                roleId: rec.roleId
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "put-accesscontrol-listvalue-team-role-in-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        function removePersonRoleInListValue(rec) {
            var data = {
                listvalueId: rec.listvalueId,
                personId: rec.personId
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-accesscontrol-listvalue-person-role-in-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }
        function removeTeamRoleInListValue(rec) {
            var data = {
                listvalueId: rec.listvalueId,
                teamId: rec.teamId
            };

            return $.Deferred(function (deferred) {
                amplify.request({
                    resourceId: "del-accesscontrol-listvalue-team-role-in-listvalue",
                    data: data,
                    success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                    error: function (result, statusCode) { deferred.reject(result, statusCode); }
                });
            }).promise();
        }

        init();

        return {
            getAccessControl: getAccessControl,

            addPersonAccessInListValue: addPersonAccessInListValue,
            addTeamAccessInListValue: addTeamAccessInListValue,

            updateAccessControl: updateAccessControl,
            updatePersonRoleInListValue: updatePersonRoleInListValue,
            updateTeamRoleInListValue: updateTeamRoleInListValue,

            removePersonRoleInListValue: removePersonRoleInListValue,
            removeTeamRoleInListValue: removeTeamRoleInListValue
        };

        //#region Internal Methods

        function init() {

            //#region 

            amplify.request.define("get-accesscontrol-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("put-accesscontrol-listvalue-person-access-in-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("put-accesscontrol-listvalue-team-access-in-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("put-accesscontrol-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("put-accesscontrol-listvalue-person-role-in-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}/person/{personId}/{roleId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {return JSON.stringify(data);}
            });

            amplify.request.define("put-accesscontrol-listvalue-team-role-in-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}/team/{teamId}/{roleId}"),
                contentType: "application/json",
                dataType: "json",
                type: "PUT",
                dataMap: function (data) { return JSON.stringify(data); }
            });

            amplify.request.define("del-accesscontrol-listvalue-person-role-in-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}/person/{personId}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("del-accesscontrol-listvalue-team-role-in-listvalue", "ajax", {
                url: getUrl("access-control/admin/listvalue/{listvalueId}/team/{teamId}"),
                dataType: "json",
                type: "DELETE"
            });
            //#endregion
        }

        function getUrl(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
